import { APP_BASE_HREF } from '@angular/common';
import { TENANT_KEY } from './tenant-key.provider';


export const baseHrefProvider = {
  provide: APP_BASE_HREF,
  deps: [TENANT_KEY],
  useFactory: (tenantKey: string) => `/${tenantKey}`
};
